import _ from "lodash";

let Category = require('./submit-task-category').default
let Description = require('./submit-task-description').default
let Budget = require('./submit-task-budget').default
let ExecutionTime = require('./submit-task-execution-time').default
let Suburb = require('./submit-task-suburb').default
let Attachment = require('./submit-task-attachment').default
let Review = require('./submit-task-review').default

export default {
  bus: new Vue({}),
  steps: {
    'Select A Category': Category,
    'Specify Suburb': Suburb,
    'Add A Description': Description,
    'Specify Execution Time': ExecutionTime,
    'Specify Budget': Budget,
    'Add Attachments': Attachment,
    // TODO login / register
    'Review': Review,
  },
  states: Vue.observable({
    loading: false,
    task: null,
    user: null,
    is_open: false,
    is_closing: false,
    step: 0,
    base_data: {},
    category: null,
    description: '',
    suburb: null,
    executionTime: null,
    budget: null,
    attachments: [],
    trader_id: null,
    execution_date_to:'',
    execution_date_from:'',
  }),
  selectCategory(value) {
    this.states.category = value
  },
  selectSuburb(value) {
    this.states.suburb = value
  },
  selectExecutionTime(value) {
    if(value != ''){
      this.states.execution_date_to = '';
      this.states.execution_date_from = '';
    }
    this.states.executionTime = value
  },
  selectBudget(value) {
    this.states.budget = value
  },
  addAttachment(file) {
    this.states.attachments.push(file)
  },
  next() {
    if (this.isLastStep()) {
      return this.submit()
    }  
    this.states.step = Math.min(this.states.step + 1, _.values(this.steps).length - 1)
  },
  prev() {
    this.states.step = Math.max(0, this.states.step - 1)
  },
  submit() {
    if (this.loading){
      return
    }

    this.loading = true
    let form = new FormData()
    _.forEach({
      task_id: _.get(this.states.task, 'id'),
      description: this.states.description,
      category_id: _.get(this.states.category, 'id'),
      suburb_id: _.get(this.states.suburb, 'id'),
      task_execution_date_id: _.get(this.states.executionTime, 'id'),
      execution_date_to: this.states.execution_date_to,
      execution_date_from: this.states.execution_date_from,
      budget_id: _.get(this.states.budget, 'id'),
      trader_id: this.states.trader_id
    }, (value, key) => form.append(key, value))

    this.states.attachments.forEach(file => form.append('attachments[]', file))

    document.addEventListener('authenticated', event => {
      let user = event.detail
      this.states.user = user
      axios({
        method: 'post',
        url: `/api/v1/task?api_token=${this.states.user.api_token}`,
        data: form,
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(resp => {
          this.loading = false
          Vue.$toast.success(resp.data.message)
          if (this.states.task === null) {
            window.location.href = '/dashboard/task'
          } else {
            this.close()
          }
          document.dispatchEvent(new CustomEvent('task-updated', {detail: resp.data.data}))
        })
        .catch(err => {
          this.loading = false
          if (err.response && err.response.status === 422) {
            _.forEach(err.response.data.errors, errors => {
              Vue.$toast.error(errors[0]);
            })
          }
        })
    }, {once: true})

    document.dispatchEvent(new CustomEvent('open-auth', {detail: {refresh: false}}))
    this.loading = false

  },
  component() {
    return _.values(this.steps)[this.states.step]
  },
  componentTitle() {
    return _.keys(this.steps)[this.states.step]
  },
  gotoStep(step) {
    this.states.step = step - 1
  },
  continue() {
    this.states.is_closing = false
  },
  close() {
    if (this.states.is_closing === false) {
      this.states.is_closing = true;
      return;
    }

    _.forEach({
      is_open: false,
      step: 0,
      category: null,
      description: '',
      suburb: null,
      executionTime: null,
      budget: null,
      attachments: [],
      task: null,
      trader_id: null,
      is_closing : false,
    }, (value, key) => {
      Vue.set(this.states, key, value)
    })
  },
  open(task) {
    this.hydrateTask(task)
    this.states.is_open = true
  },
  openWithDefaults(values) {
  
    _.forEach(values, (value, key) => this.states[key] = value)
    this.states.is_open = true
    if(values.category) {
      this.states.step = 1
    }

    if(values.category && values.suburb) {
      this.states.step = 2
    }

  },
  hydrateUser(user) {
    this.states.user = user
  },
  hydrateTask(task) {
    this.states.task = task
    if (task !== null) {
      this.states.category = task.category
      this.states.suburb = task.suburb
      this.states.budget = task.budget
      this.states.executionTime = task.execution_date
      this.states.description = task.description
    }
  },
  hydrateBaseData(data) {
    _.forEach(data, (value, key) => this.states.base_data[key] = value)
  },
  deleteAttachment(attachment) {
    axios.delete(`/api/v1/task/${this.states.task.id}/attachment/${attachment.id}?api_token=${this.states.user.api_token}`)
      .then(resp => {
        Vue.$toast.success(resp.data.message)
        this.states.task = resp.data.data
      })
  },
  totalSteps() {
    return _.values(this.steps).length
  },
  isLastStep() {
    return this.totalSteps() === this.states.step + 1
  },
}
